"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Collapsible", {
  enumerable: true,
  get: function get() {
    return _Collapsible.default;
  }
});

var _Collapsible = _interopRequireDefault(require("./Collapsible"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./node_modules/@contently/toolkit/dist/containers/collapsible/index.js
// module id = 667
// module chunks = 0 15 16 17 18